// @flow
import { GreenUpDayScreen } from "./green-up-day-screen";

export default GreenUpDayScreen;
